<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <v-col cols="12" md="12">
        <v-data-table 
          :loading="loading.clients" 
          :items="clients" 
          :headers="headers" 
          :search="search_data_table"
          v-if="!readonly"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search_data_table"
              label="Buscar"
              class="mx-4"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{item}" v-if="!readonly">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="removeClient(item.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Remover cliente do grupo</span>
            </v-tooltip>    
          </template>
        </v-data-table>
        
        <!-- Modo somente leitura -->
        <v-data-table 
          :items="clients" 
          :headers="readonly_headers" 
          v-if="readonly"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: 'EconomicGroupClientsForm',
  mixins: [validations],
  props: {
    economic_group: {
      required: true,
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      headers: [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'Cidade', value: 'attributes.city', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' },
      ],
      readonly_headers: [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'Cidade', value: 'attributes.city', align: 'center' },
      ],
      search_data_table: '',
      clients: [],
      loading: {
        clients: false
      }
    }
  },
  methods: {
    getClients(){
      this.loading.clients = true
      let params = { 
        economic_group_id: this.economic_group.id
      }
      Api.Client.index(params).then((res)=>{
        this.clients = [...res.data?.data]
      }).catch(er => {
        console.error(er)
      }).finally(()=>{
        this.loading.clients = false
      })
    },
    removeClient(id){
      this.swallConfirmation({
        title: 'Deseja remover este cliente do grupo?',
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          // Aqui você implementaria a remoção do cliente do grupo
          // Por enquanto, apenas remove da lista local
          this.clients = this.clients.filter(client => client.id !== id)
          this.successSaved()
        }
      })
    },
    validate(){
      return this.$refs.form.validate()
    },
  },
  mounted() {
    this.getClients()
  },
}
</script>

